import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Building2 } from 'lucide-react';
import { useSite } from '@/context/SiteContext';

export default function SiteSelector() {
  const { selectedSiteId, setSelectedSiteId, sites, loading, isSuperAdmin } = useSite();

  // Only show for super admin
  if (!isSuperAdmin || loading) {
    return null;
  }

  const handleSiteChange = (value) => {
    setSelectedSiteId(value);
  };

  const getDisplayValue = () => {
    if (selectedSiteId === 'all_sites') {
      return 'All Sites';
    }
    const site = sites.find(s => s.site_id === selectedSiteId);
    return site ? site.name : 'Select Site';
  };

  return (
    <div className="flex items-center gap-2" data-testid="site-selector">
      <Building2 className="h-5 w-5 text-slate-500" />
      <Select value={selectedSiteId || 'all_sites'} onValueChange={handleSiteChange}>
        <SelectTrigger className="w-64 h-10 bg-white border-slate-300" data-testid="site-selector-trigger">
          <SelectValue>{getDisplayValue()}</SelectValue>
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="all_sites" data-testid="site-option-all">All Sites</SelectItem>
          {sites.map((site) => (
            <SelectItem key={site.site_id} value={site.site_id} data-testid={`site-option-${site.site_id}`}>
              {site.name} ({site.type === 'mechanical' ? 'Mechanical' : 'Smash Repair'})
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}